export default __webpack_public_path__ + "static/media/Ecobank_Logo_EN.89a33f31.png";